export const indexLayoutSidebar = 56
export const leftWidth = 240
export const leftMaxWidth = 364
export const rightWidth = 350
export const canvasFirstRightWidth = 300
export const defaultPaddingForTouchDevices = 72
